import Backbone from 'backbone'

const PurchasedModel = Backbone.Model.extend({
    defaults: {
        _id: null,
    }
})

export default PurchasedModel
